import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const FileIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.text.default,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 15.75C16 16.9926 14.9926 18 13.75 18H6.25C5.00736 18 4 16.9926 4 15.75V4.25C4 3.00736 5.00736 2 6.25 2H10.9393C11.5361 2 12.1084 2.23705 12.5303 2.65901L15.341 5.46967C15.7629 5.89163 16 6.46392 16 7.06066V15.75ZM5.5 4.25C5.5 3.83579 5.83579 3.5 6.25 3.5H10V6.5C10 7.32843 10.6716 8 11.5 8H14.5V15.75C14.5 16.1642 14.1642 16.5 13.75 16.5H6.25C5.83579 16.5 5.5 16.1642 5.5 15.75V4.25ZM14.25 6.5L11.5 3.75V6.5H14.25Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
